/**
 * UserContent 组件
 * 用于渲染用户消息内容，包括头像、文件附件和文本内容
 */
import React from 'react';

import { useAuth } from '../../../../lib/auth/AuthProvider';
import { getUserDisplayName, getUserAvatarUrl } from '../../../../utils/userUtils';
import { Message } from '../../../../types';
import { MessageFileAttachments } from './MessageFileAttachments';

interface UserContentProps {
  message: Message;
  getAvatarBackgroundColor: string;
}

export const UserContent: React.FC<UserContentProps> = ({
  message,
  getAvatarBackgroundColor
}) => {

  const { user } = useAuth();

  // 渲染用户消息内容
  const renderUserContent = () => {
    if (Array.isArray(message.content)) {
      const textContentItem = message.content.find(item => item.type === 'text');
      if (textContentItem && typeof textContentItem.text === 'string') {
        const formattedText = textContentItem.text.split('\n').map((line: string, i: number, arr: string[]) => (
          <React.Fragment key={i}>{line}{i < arr.length - 1 && <br />}</React.Fragment>
        ));
        return <p>{formattedText}</p>;
      }
    } else if (typeof message.content === 'string') {
      return <p>{message.content}</p>;
    }
    return null;
  };

  // 获取用户头像
  const userAvatarUrl = getUserAvatarUrl(user);
  const userName = getUserDisplayName(user);

  return (
    <div className="flex justify-end w-full items-center">
      <div className="max-w-[85%] px-3 py-2 rounded-2xl shadow-sm text-sm bg-ios-blue text-white rounded-br-none">
        {/* 渲染文件附件 */}
        {Array.isArray(message.content) && (
          <MessageFileAttachments content={message.content} />
        )}

        {/* 用户文本内容 */}
        {renderUserContent()}
      </div>

      {/* NOTE: 暂时隐藏但是不要删掉代码 - 用户头像 */}
      {/* <div className={`w-8 h-8 rounded-full ${getAvatarBackgroundColor} flex items-center justify-center text-white text-xs font-semibold ml-2 flex-shrink-0 overflow-hidden`}>
        {userAvatarUrl ? (
          <img src={userAvatarUrl} alt={userName} className="w-full h-full object-cover" />
        ) : (
          userName.charAt(0)
        )}
      </div> */}
    </div>
  );
};

export default UserContent;
